<template>
    <DCard
        padding
    >
        <DTable
            class="table-responsive"
            :fields="getFields"
            :items="taxExemptions"
        >
            <template #invoice_text="{item}">
                <td>{{ shortenText(item.invoice_text) }}</td>
            </template>
            <template #no_tax_on_invoice="{item}">
                <td>{{ item.no_tax_on_invoice ? __('settings.tax_exemptions.index.table.values.tax_on_invoice.yes') : __('settings.tax_exemptions.index.table.values.tax_on_invoice.no') }}</td>
            </template>
            <template #tax_key_credit_note="{item}">
                <td>
                    {{ item.tax_key_credit_note !== null ? item.tax_key_credit_note : '' }}
                </td>
            </template>
            <template #expense_account_credit_note="{item}">
                <td>
                    {{ item.expense_account_credit_note !== null ? item.expense_account_credit_note : '' }}
                </td>
            </template>
            <template #allow_credit_note="{item}">
                <td>
                    {{ item.allow_credit_note ? __('settings.tax_exemptions.index.table.values.tax_on_invoice.yes') : __('settings.tax_exemptions.index.table.values.tax_on_invoice.no') }}
                </td>
            </template>
            <template #intercompany="{item}">
                <td>
                    {{ item.intercompany ? __('settings.tax_exemptions.index.table.values.tax_on_invoice.yes') : __('settings.tax_exemptions.index.table.values.tax_on_invoice.no') }}
                </td>
            </template>
            <template #intercompany_cost_center="{item}">
                <td>
                    {{ item.intercompany_cost_center !== null ? item.intercompany_cost_center : '' }}
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px">
                        <DButton
                            :id="`edit_${item.id}`"
                            icon="pencil"
                            mini
                            @click="$inertia.get($route('settings.tax-exemption.edit', {tax_exemption: item.id}))"
                        />
                        <DButton
                            :id="`btn-delete-${item.id}`"
                            icon="trash-can-outline"
                            mini
                            color="danger"
                            :disabled="item.customersCount > 0 || isInLoadingState"
                            @click="deleteTaxExemption(item)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.tax_exemptions.index.add_tax_exemption_button')"
                @click="$inertia.get($route('settings.tax-exemption.create'))"
            />
        </DFabs>

        <DModal
            v-model:show="showConfirmationModal"
            :title="__('settings.tax_exemptions.index.delete_confirm_modal.title')"
            :message="__('settings.tax_exemptions.index.delete_confirm_modal.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </DCard>
</template>

<script>
export default {
    name: 'TaxExemptionIndex',
    props: {
        taxExemptions: {
            type: Array,
            default: () => { return [] }
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    data () {
        return {
            showConfirmationModal: false,
            deleteCallBack: () => { return {} }
        }
    },
    computed: {
        getFields () {
            if (this.isFinanceSystemNetsuite === true) {
                return [
                    { key: 'id', label: this.__('settings.tax_exemptions.index.table.headers.id'), sorter: false, filter: false },
                    { key: 'name', label: this.__('settings.tax_exemptions.index.table.headers.name'), sorter: false, filter: false },
                    { key: 'invoice_text', label: this.__('settings.tax_exemptions.index.table.headers.invoice_text'), sorter: false, filter: false },
                    { key: 'tax_key_invoice', label: this.__('settings.tax_exemptions.index.table.headers.tax_key_invoice'), sorter: false, filter: false },
                    { key: 'no_tax_on_invoice', label: this.__('settings.tax_exemptions.index.table.headers.no_tax'), sorter: false, filter: false },
                    { key: 'tax_key_credit_note', label: this.__('settings.tax_exemptions.index.table.headers.tax_key_credit_note'), sorter: false, filter: false },
                    { key: 'allow_credit_note', label: this.__('settings.tax_exemptions.index.table.headers.allow_credit_note'), sorter: false, filter: false },
                    { key: 'intercompany', label: this.__('settings.tax_exemptions.index.table.headers.intercompany'), sorter: false, filter: false },
                    { key: 'actions', label: '', sorter: false, filter: false }
                ]
            }

            return [
                { key: 'id', label: this.__('settings.tax_exemptions.index.table.headers.id'), sorter: false, filter: false },
                { key: 'name', label: this.__('settings.tax_exemptions.index.table.headers.name'), sorter: false, filter: false },
                { key: 'invoice_text', label: this.__('settings.tax_exemptions.index.table.headers.invoice_text'), sorter: false, filter: false },
                { key: 'tax_key_invoice', label: this.__('settings.tax_exemptions.index.table.headers.tax_key_invoice'), sorter: false, filter: false },
                { key: 'revenue_account_invoice', label: this.__('settings.tax_exemptions.index.table.headers.revenue_account_invoice'), sorter: false, filter: false },
                { key: 'no_tax_on_invoice', label: this.__('settings.tax_exemptions.index.table.headers.no_tax'), sorter: false, filter: false },
                { key: 'tax_key_credit_note', label: this.__('settings.tax_exemptions.index.table.headers.tax_key_credit_note'), sorter: false, filter: false },
                { key: 'expense_account_credit_note', label: this.__('settings.tax_exemptions.index.table.headers.expense_account_credit_note'), sorter: false, filter: false },
                { key: 'allow_credit_note', label: this.__('settings.tax_exemptions.index.table.headers.allow_credit_note'), sorter: false, filter: false },
                { key: 'intercompany', label: this.__('settings.tax_exemptions.index.table.headers.intercompany'), sorter: false, filter: false },
                { key: 'intercompany_cost_center', label: this.__('settings.tax_exemptions.index.table.headers.intercompany_cost_center'), sorter: false, filter: false },
                { key: 'actions', label: '', sorter: false, filter: false }
            ]
        }
    },
    methods: {
        shortenText (text) {
            return text.length > 55 ? text.substr(0, 55) + '...' : text
        },
        deleteTaxExemption (taxExemption) {
            this.deleteCallBack = () => {
                this.$inertia.delete(this.$route('settings.tax-exemption.destroy', { tax_exemption: taxExemption.id }))
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        }
    }
}
</script>
